import axios2 from '../api/axios';
export const freightServices = {
    createfreight,
    updatefreight,
    getmanufacturer,
    deletemanufacturer,
    getproductname,    
    getallfreight,
}

function createfreight(objdata){
    return axios2.post(`/createfreight`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function updatefreight(objdata){
    return axios2.post(`/updatefreight`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

 function deletemanufacturer(id){
     return axios2.post(`/deletemanufacturer`,id,((response)=>{
          return response;   
     })).catch((error)=>{
          console.log(error); 
     })  
 }
 
function getmanufacturer(page,pageSize){
    return axios2.get(`/getmanufacturer?page=${page}&limit=${pageSize}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getproductname(id=0){
    return axios2.get(`/getproductname/${id}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getallfreight(page,pageSize){
     return axios2.get(`/getallfreight?page=${page}&limit=${pageSize}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}